import { render, staticRenderFns } from "./TeamPerformance.vue?vue&type=template&id=0349011c&scoped=true"
import script from "./TeamPerformance.vue?vue&type=script&lang=js"
export * from "./TeamPerformance.vue?vue&type=script&lang=js"
import style0 from "./TeamPerformance.vue?vue&type=style&index=0&id=0349011c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0349011c",
  null
  
)

export default component.exports